module.exports = __webpack_public_path__ + "media/snacks/some-treats-4a033e6d.svg";